/**
 * The language the user sees the app in, as a value the backend can use.
 *
 * Server side text (the What's new announcement) is written once per post in
 * the language of the opening device, so the app sends it on every request as
 * `X-User-Locale`. The source of truth is the i18n instance the UI itself
 * renders from, never `navigator.language` on its own.
 */

import i18n from 'i18next';

/** Request header carrying the UI language. */
export const USER_LOCALE_HEADER = 'X-User-Locale';

/** Values the header can take. Keep in step with `SUPPORTED_LANGUAGES` in `@/i18n`. */
export type UserLocale = 'en' | 'es';

/**
 * The active UI language reduced to its primary subtag and clamped to a
 * supported value ("es-MX" becomes "es"; anything else, or an i18n instance that
 * is not initialised, becomes "en").
 */
export function getUserLocale(): UserLocale {
  const raw = i18n.resolvedLanguage || i18n.language || '';
  const primary = raw.toLowerCase().split(/[-_]/)[0];
  return primary === 'es' ? 'es' : 'en';
}
